/**
 * Opens a URL in a new browser tab with the safe rel flags (`noopener`,
 * `noreferrer`).
 *
 * Returns the opened `Window` or `null`. NOTE: because `noopener`/`noreferrer`
 * are set, the browser returns `null` even on a successful open, so the return
 * value cannot be used to detect a popup that was blocked.
 */
export const openExternal = (url: string): Window | null =>
  window.open(url, '_blank', 'noopener,noreferrer')
